import { render, staticRenderFns } from "./new-device.vue?vue&type=template&id=ee3522c8"
import script from "./new-device.vue?vue&type=script&lang=js"
export * from "./new-device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee3522c8')) {
      api.createRecord('ee3522c8', component.options)
    } else {
      api.reload('ee3522c8', component.options)
    }
    module.hot.accept("./new-device.vue?vue&type=template&id=ee3522c8", function () {
      api.rerender('ee3522c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/new-device.vue"
export default component.exports